import { Amex, Card as CardIcon, Diners, Discover, Jcb, Mastercard, UnionPay, Visa } from 'assets/images'

export const renderCardIcon = (type) => {

  switch (type?.toLowerCase()) {
    case "visa":
      return <img width={54} src={Visa} alt="visa" />;
    case "mastercard":
      return <img width={54} src={Mastercard} alt="mastercard" />;
    case "amex":
      return <img width={54} src={Amex} alt="amex" />;
    case "discover":
      return <img width={54} src={Discover} alt="discover" />;
    case "diners":
      return <img width={54} src={Diners} alt="diners" />;
    case "jcb":
      return <img width={54} src={Jcb} alt="jcp" />;
    case "unionpay":
      return <img width={54} src={UnionPay} alt="unionpay" />;
    default:
      return <img width={54} src={CardIcon} alt="" />;
  }
}